export default "__VITE_ASSET__Db1J5CVf__"